import { Component, Input } from '@angular/core';
import {
  TangramMetrics,
  TangramPerfRow,
  TrendDelta
} from '../../models/analytics.types';

@Component({
  selector: 'tangram-pa-overview-tab',
  templateUrl: './overview-tab.component.html',
  styleUrls: ['./overview-tab.component.scss']
})
export class OverviewTabComponent {
  @Input() myTangramsCount = 0;
  @Input() tangramMetrics: TangramMetrics = { views: 0, uniqueUsers: 0, completionRate: 0, avgTimeSpent: '0m' };
  @Input() topTangrams: TangramPerfRow[] = [];
  @Input() lowTangrams: TangramPerfRow[] = [];
  @Input() trends: { [key: string]: TrendDelta } = {};

  trend(key: string): TrendDelta {
    return this.trends[key] || { delta: 0, unit: '' };
  }
}
